import { ReactElement } from "react";

import { useEffect, useState } from "react";

type Props = {
    className?: string;
    size?: number;
};

export default function SVGCross({
    className,
    size = 20,
}: Props): ReactElement {
    const scale = size / 20;

    return (
        <svg
            className={className}
            width={`${size}px`}
            height={`${size}px`}
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            viewBox={`0 0 ${size} ${size}`}
        >
            <line
                x1={1.3 * scale}
                y1={1.3 * scale}
                x2={18.7 * scale}
                y2={18.7 * scale}
                strokeWidth={`${Math.floor(3 * scale)}px`}
                stroke="currentColor"
            />
            <line
                x1={1.3 * scale}
                y1={18.7 * scale}
                x2={18.7 * scale}
                y2={1.3 * scale}
                strokeWidth={`${Math.floor(3 * scale)}px`}
                stroke="currentColor"
            />
        </svg>
    );
}
